const messages = {
  title: 'Intern feil',
  description: 'Data for denne siden kan ikkje lastes inn riktig.',
  backHomeButton: 'Attende til dashbord'
}

export default {
  messages
}
